module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_1.1010e642.jpg";